<template>
  <div class="aboutus-8v-page">
    <div class="page-banner">
      <video muted="true" loop="" autoplay="autoplay" class="bgvideo">
        <source
          type="video/mp4"
          src="../../assets/img/aboutus-8v/aboutus.mp4"
        />
      </video>

      <!-- <div
        :class="language == 'zh_CN' ? 'logo-slogan' : 'logo-slogan-en'"
      ></div> -->
      <div class="logo-slogan">
        <img src="../../assets/img/bv/banner-logo.png" class="lg" />
        <!-- <span class="mt">{{
          language == "en"
            ? "The world’s first Metaverse ecosystem digital asset exchange."
            : translateTitle("全球首家元宇宙生态数字资产交易所")
        }}</span>
        <span class="st">{{
          language == "en"
            ? "Headquartered in London, UK, with operation spanning over the world."
            : translateTitle("总部位于英国伦敦，营运能量辐射全球")
        }}</span> -->
        <span class="mt">{{
          translateTitle("全球首家元宇宙生态数字资产交易所")
        }}</span>
        <!-- <span class="st">{{
          translateTitle("总部位于英国伦敦，营运能量辐射全球")
        }}</span> -->
      </div>
      <div class="rectangle">
        <div class="more-button" @click="doShowIntroduction">
          <span>{{ translateTitle("more") }}</span
          ><i
            v-show="!isShowIntroduction"
            class="iconfont iconsize16-1 down"
          ></i
          ><i v-show="isShowIntroduction" class="iconfont iconsize16-1 up"></i>
        </div>
      </div>
    </div>
    <div class="rectangle-content" v-show="isShowIntroduction">
      <p class="introduction">
        <span class="site-name">{{ "8V.com" }}</span
        >{{
          translateTitle(
            "是全球领先的区块链技术服务商，成⽴于2021年，总部位于英国。我们致⼒于⾼效搭建沉浸感、社交性和实时性的元宇宙⽣态模块，已拥有数字资产交易系统、钱包等成熟的产品线。"
          )
        }}
        <br />
        <br />
        {{
          translateTitle(
            "团队成员均来⾃国际顶级⾦融机构、计算机应⽤等领域，汇聚亚洲，欧洲和美洲的⾦融专业⼈才和区块链技术专业⼈才。"
          )
        }}
        <span class="site-name" style="display: inline">{{ "8V.com" }}</span
        >{{
          translateTitle(
            "致力打造世界第一个围绕着元宇宙生态圈的数字资产交易所，并将以节能减碳为目标，助力虚拟货币对环境的永续发展。"
          )
        }}
      </p>
    </div>

    <div class="ecosystem">
      <span class="title-ecosystem">{{ translateTitle("元宇宙生态圈") }}</span>
      <!-- <img
        class="img-ecosystem"
        :src="language == 'zh_CN' ? ecosystem : ecosystem_en"
      /> -->
      <div class="img-ecosystem">
        <div class="tc" :style="{ display: eco_active == 1 ? '' : 'none' }">
          <span class="t">{{ translateTitle("数字货币") }}</span>
          <p class="c">
            {{ translateTitle("元宇宙经济基础，支持所有链上元宇宙相关币种") }}
          </p>
        </div>
        <div class="tc" :style="{ display: eco_active == 2 ? '' : 'none' }">
          <span class="t">{{ translateTitle("DEFI") }}</span>
          <p class="c">
            {{ translateTitle("支持区块链Defi架构应用，倍增理财投资广度") }}
          </p>
        </div>
        <div class="tc" :style="{ display: eco_active == 3 ? '' : 'none' }">
          <span class="t">{{ translateTitle("投资") }}</span>
          <p class="c">
            {{ translateTitle("支持元宇宙生态项目投资，致力打造友善生态") }}
          </p>
        </div>
        <div class="tc" :style="{ display: eco_active == 4 ? '' : 'none' }">
          <span class="t">{{ translateTitle("社交") }}</span>
          <p class="c">
            {{ translateTitle("逐步连结元宇宙社群，创造元宇宙社交投资") }}
          </p>
        </div>
        <div class="tc" :style="{ display: eco_active == 5 ? '' : 'none' }">
          <span class="t">{{ translateTitle("GameFi") }}</span>
          <p class="c">
            {{ translateTitle("元宇宙生态应用重点，全面支持游戏经济") }}
          </p>
        </div>
        <div class="tc" :style="{ display: eco_active == 6 ? '' : 'none' }">
          <span class="t">{{ translateTitle("NFT") }}</span>
          <p class="c">
            {{ translateTitle("元宇宙打造元件，未来支持NFT交易市场") }}
          </p>
        </div>

        <div
          class="first"
          :class="eco_active == 1 ? 'active' : ''"
          @mouseenter="chooseEco(1)"
        >
          <span class="text">{{ translateTitle("数字货币") }}</span>
        </div>
        <div
          class="second"
          :class="eco_active == 2 ? 'active' : ''"
          @mouseenter="chooseEco(2)"
        >
          <span class="text">{{ translateTitle("DEFI") }}</span>
        </div>
        <div
          class="third"
          :class="eco_active == 3 ? 'active' : ''"
          @mouseenter="chooseEco(3)"
        >
          <span class="text">{{ translateTitle("投资") }}</span>
        </div>
        <div
          class="fourth"
          :class="eco_active == 4 ? 'active' : ''"
          @mouseenter="chooseEco(4)"
        >
          <span class="text">{{ translateTitle("社交") }}</span>
        </div>
        <div
          class="fifth"
          :class="eco_active == 5 ? 'active' : ''"
          @mouseenter="chooseEco(5)"
        >
          <span class="text">{{ translateTitle("GameFi") }}</span>
        </div>
        <div
          class="sixth"
          :class="eco_active == 6 ? 'active' : ''"
          @mouseenter="chooseEco(6)"
        >
          <span class="text">{{ translateTitle("NFT") }}</span>
        </div>
      </div>
    </div>

    <div class="site-data">
      <div class="data-content">
        <div class="data-item">
          <span class="data">200x</span>
          <span class="title">{{ translateTitle("杠杆") }}</span>
        </div>
        <div class="data-item">
          <span class="data">500M+</span>
          <span class="title">{{ translateTitle("交易/每秒") }}</span>
        </div>
        <div class="data-item">
          <span class="data">24/7</span>
          <span class="title">{{ translateTitle("帮助中心") }}</span>
        </div>
      </div>
    </div>

    <div class="advantages">
      <div class="title-cn-english">
        <span class="title-cn">{{ translateTitle("我们的优势") }}</span>
      </div>
      <div class="advantages-items">
        <div class="advantages-item-both">
          <div class="advantages-item-one">
            <img class="advantages-item-img" :src="advantages1" />
            <!-- <p class="advantages-item-p" style="width:364px;"> -->
            <p class="advantages-item-p" style="max-width: 342px">
              <!-- {{ translateTitle("全球首家元宇宙生态交易所，元宇宙币种最全") }} -->
              {{ translateTitle("全球首家元宇宙生态交易所") }}
            </p>
          </div>
          <div class="advantages-item-two">
            <img class="advantages-item-img" :src="advantages4" />
            <!-- <p class="advantages-item-p" style="width:252px;"> -->
            <p class="advantages-item-p" style="max-width: 342px">
              <!-- {{ translateTitle("全球交易深度最高的交易所，稳定防插针") }} -->
              {{ translateTitle("交易深度最高，稳定防插针") }}
            </p>
          </div>
        </div>

        <div class="space"></div>

        <div class="advantages-item-both">
          <div class="advantages-item-one">
            <img class="advantages-item-img" :src="advantages2" />
            <!-- <p class="advantages-item-p" style="width:280px;"> -->
            <p class="advantages-item-p" style="max-width: 342px">
              <!-- {{ translateTitle("全球交易手续费最低的交易所，超低交易损耗") }} -->
              {{ translateTitle("拥有最全的元宇宙概念币种") }}
            </p>
          </div>
          <div class="advantages-item-two">
            <img class="advantages-item-img" :src="advantages5" />
            <!-- <p class="advantages-item-p" style="width:280px;"> -->
            <p class="advantages-item-p" style="max-width: 342px">
              <!-- {{ translateTitle("匹配独立资产保险库，冷热钱包双机制管理") }} -->
              {{ translateTitle("先进的混币技术，链上匿名") }}
            </p>
          </div>
        </div>

        <div class="space"></div>
        <div class="advantages-item-both">
          <div class="advantages-item-one">
            <img class="advantages-item-img" :src="advantages3" />
            <!-- <p class="advantages-item-p" style="width:370px;"> -->
            <p class="advantages-item-p" style="max-width: 342px">
              <!-- {{ translateTitle("套利量化理财产品收益全网最高，APR高达80%") }} -->
              {{ translateTitle("套利理财产品收益全网最高") }}
            </p>
          </div>
          <div class="advantages-item-two">
            <img class="advantages-item-img" :src="advantages6" />
            <!-- <p class="advantages-item-p" style="width:280px;"> -->
            <p class="advantages-item-p" style="max-width: 342px">
              <!-- {{ translateTitle("拥有先进的混币技术，链上匿名安全") }} -->
              {{ translateTitle("冷热钱包双机制，资产安全") }}
            </p>
          </div>
        </div>
      </div>
      <div class="title-team-cn-english">
        <span class="title-cn">{{ translateTitle("我们的团队") }}</span>
      </div>
    </div>

    <div class="team">
      <div
        class="team-item"
        @mouseenter="doShowItem(1)"
        @mouseleave="doShowItem(0)"
      >
        <div style="position: relative">
          <img :src="nick" class="item-image" />
          <div class="cover" v-if="isShowItem != 0 && isShowItem != 1"></div>
        </div>
        <span class="item-name">{{ "Nick Cook" }}</span>
        <span class="item-work">{{ "COO" }}</span>
      </div>
      <div class="space"></div>
      <div
        class="team-item"
        @mouseenter="doShowItem(2)"
        @mouseleave="doShowItem(0)"
      >
        <div style="position: relative">
          <img :src="ben" class="item-image" />
          <div class="cover" v-if="isShowItem != 0 && isShowItem != 2"></div>
        </div>
        <span class="item-name">{{ "Ben Cronin" }}</span>
        <span class="item-work">{{ "GM" }}</span>
      </div>
      <div class="space"></div>
      <div
        class="team-item"
        @mouseenter="doShowItem(3)"
        @mouseleave="doShowItem(0)"
      >
        <div style="position: relative">
          <img :src="roland" class="item-image" />
          <div class="cover" v-if="isShowItem != 0 && isShowItem != 3"></div>
        </div>
        <span class="item-name">{{ "Roland Masterton" }}</span>
        <span class="item-work">{{ "CHO" }}</span>
      </div>
    </div>

    <div class="name-introduction" v-if="isShowItem == 1">
      <div class="name-work">
        <span class="name">{{ "Nick Cook" }}</span>
        <span class="work">{{ "Chief Operating Officer at 8V.com" }}</span>
      </div>
      <p class="work-content">
        {{
          translateTitle(
            `一位经验丰富、积极进取且充满活力的领导者，在汽⻋、制造、航空和金融科技管理谘询领域拥有丰富的工作经验。面对客户跟投资人之间的鸿沟，金融业的核心业务是交易，而交易的定义是“价值交换”。而区块链将会彻底改变未来的价值交换模式，具备去中心化、开放性、公开透明、不可窜改等特性。由于区块链运作不需要第三方中介机构的信任凭证或认证，因此无论应用于交易或资讯交换，都能大幅度提升速度与安全性，并显著降低成本。`
          )
        }}
      </p>
    </div>
    <div class="name-introduction" v-if="isShowItem == 2">
      <div class="name-work">
        <span class="name">{{ "Ben Cronin" }}</span>
        <span class="work">{{ "General Manager at 8V.com" }}</span>
      </div>
      <p class="work-content">
        {{
          translateTitle(
            `一位专业且友善的开发经理/专案经理， 在游戏、网络和移动开发方面拥有超过 20年的直接经验。致力于透过各项KPI 测评分析现况，解决企业在领导力发展、变革管理及人才管理等各方面的复杂问题与挑战，并提高企业的经营绩效。他认为领导者应像一位厨师，花费精力去了解各式各样的食材，并思考如何从中带出最佳⻛味，创造最佳的化学效应。`
          )
        }}
      </p>
    </div>
    <div class="name-introduction" v-if="isShowItem == 3">
      <div class="name-work">
        <span class="name">{{ "Roland Masterton" }}</span>
        <span class="work">{{ "Chief HumanResource Officer at 8V.com" }}</span>
      </div>
      <p class="work-content">
        {{
          translateTitle(
            `我认为诚实是最好的技术.开诚布公地 阐明理想，以及其愿意为了实现目标而有所牺牲。我们正处于一全新人工智能驱动时代的萌芽时期，我们不仅仅为了获利而解决问题，更为了我们的愿景及使命 – 让人们能够共同参与并建造他们的未来。身为领袖的其中一个挑战便是 要给予人们充足的机会能参与和贡献，这需要自制力以让其他人有发挥领导才 能的空间，也只有这样，人们才会将共同目标视为“自己的事”`
          )
        }}
      </p>
    </div>

    <div class="vision">
      <div class="vision-content">
        <span class="title-small">{{ translateTitle("品牌愿景") }}</span>
        <span class="title-big">{{ translateTitle("建立元宇宙生态") }}</span>
        <p class="slogan-one" style="width: 85%">
          {{
            translateTitle(
              `我们致力串流国际性高端人才和资源，专注于顶尖设计、互联互通开发技术，提供最齐全的元宇宙币种、最低交易手续费以及最高交易深度，助力打造引领全球实现真正的元宇宙虚拟世界生态系统。`
            )
          }}
        </p>
        <div class="more-button" @click="doShowSlogan">
          <span>{{ translateTitle("more") }}</span
          ><i v-show="!isShowSlogan" class="iconfont iconsize16-1 down"></i
          ><i v-show="isShowSlogan" class="iconfont iconsize16-1 up"></i>
        </div>
        <p class="slogan-two" style="width: 95%" v-if="isShowSlogan">
          {{
            translateTitle(
              "我们也将同时帮助用户打造方便的理财管理，推出On-Demand/定期借贷等贷款服务，以及协助您资产增值的服务，像是投资教学或与投资界网红和KOL互动等。 8V.com用户在未来将可建立自己的元宇宙社交网络，同时可畅游多种“增加财富”的智能游戏，进一步提升资产。"
            )
          }}
        </p>
        <p class="slogan-three" v-if="isShowSlogan">
          {{ translateTitle("持续引领加密货币交易牛市!") }}
        </p>
      </div>
    </div>

    <div class="centric">
      <div class="centric-content">
        <span class="title-small">{{ translateTitle("企业使命") }}</span>
        <span class="title-big">{{ translateTitle("用户为中心") }}</span>
        <p class="slogan-one" style="width: 63%">
          {{
            translateTitle(
              `8V.com将以“用户为中心”的理念，致力于为全球散户和机构客户提供专业、智能、便捷和创新的在线交易，并结合游戏与社交让打造最优质的虚拟娱乐世界。`
            )
          }}
        </p>
        <div class="more-button" @click="doShowCentric">
          <span>{{ translateTitle("more") }}</span
          ><i v-show="!isShowCentric" class="iconfont iconsize16-1 down"></i
          ><i v-show="isShowCentric" class="iconfont iconsize16-1 up"></i>
        </div>
        <p class="slogan-two" style="width: 95%" v-if="isShowCentric">
          {{
            translateTitle(
              "我们坚持安全、高效、公平和透明的交易环境，同时注入绿色概念，以环保创造永续发展为核心，每个交易捐献1美分给慈善机构植树，聚焦环境保护，擘造高优质的「绿色金融」为地球尽一份心力。"
            )
          }}
        </p>
        <!-- <p class="slogan-three" v-if="isShowCentric">
          {{ translateTitle("持续引领加密货币交易牛市!") }}
        </p> -->
      </div>
    </div>

    <div class="customer">
      <a href="mailto:support@8v.com" class="customer-item">
        <img :src="bottom1n" class="item-image" />
        <span class="work-title" v-if="language == 'en'">{{ "SERVICE" }}</span>
        <span class="work-title" v-else>{{ translateTitle("客服") }}</span>
        <a href="mailto:support@8v.com" class="work-subTitle">{{
          translateTitle("support@8v.com")
        }}</a>
      </a>
      <div class="space"></div>
      <a href="mailto:business@8V.com" class="customer-item">
        <img :src="bottom2n" class="item-image" />
        <span class="work-title">{{
          translateTitle("商务").toUpperCase()
        }}</span>
        <a href="mailto:business@8V.com" class="work-subTitle">{{
          translateTitle("business@8V.com")
        }}</a>
      </a>
      <div class="space"></div>
      <a href="mailto:marketing@8v.com" class="customer-item">
        <img :src="bottom3n" class="item-image" />
        <span class="work-title">{{
          translateTitle("市场").toUpperCase()
        }}</span>
        <a href="mailto:marketing@8v.com" class="work-subTitle">{{
          translateTitle("marketing@8v.com")
        }}</a>
      </a>
      <!-- <div class="space"></div>
      <a href="https://t.me/official_8v_com" class="customer-item">
        <img
          :src="bottom4"
          class="item-image"
          style="width:76px;height:76px;"
        />
        <span class="work-title">{{ translateTitle("社群") }}</span>
        <a
          href="https://t.me/official_8v_com"
          target="_blank"
          class="work-subTitle"
          >{{ translateTitle("contact us") }}</a
        >
      </a> -->
    </div>
    <div class="contract" v-if="language == 'zh_CN' || language == 'zh_HK'">
      <a href="https://www.facebook.com/8V.Asia" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/fb.png" class="im" />
        <span class="text">Facebook</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a href="https://www.instagram.com/8v.asia/" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/Ins.png" class="im" />
        <span class="text">Instagram</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <!-- <a href="" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/me.png" class="im" />
        <span class="text">Medium</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a href="" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/di.png" class="im" />
        <span class="text">Discord</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a href="" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/tw.png" class="im" />
        <span class="text">Twitter</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a href="" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/re.png" class="im" />
        <span class="text">Reddit</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a> -->
      <a href="https://t.me/official_8v_com" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/tg.png" class="im" />
        <span class="text">Telegram</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a href="https://t.me/official_8v_group" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/tg.png" class="im" />
        <span class="text">Telegram{{ translateTitle("交流群") }}</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a
        href="https://www.youtube.com/channel/UCiB2p7qbFcGMII1_1YKUOYQ"
        target="_blank"
        class="it"
      >
        <img src="../../assets/img/aboutus-8v/contract/yt.png" class="im" />
        <span class="text">Youtube</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
    </div>
    <div class="contract" v-else>
      <a href="https://www.facebook.com/8V.Global/" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/fb.png" class="im" />
        <span class="text">Facebook</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a href="https://www.instagram.com/8v.global/" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/Ins.png" class="im" />
        <span class="text">Instagram</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a href="https://medium.com/@8v.global" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/me.png" class="im" />
        <span class="text">Medium</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a href="https://discord.gg/yQusCKf3tN" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/di.png" class="im" />
        <span class="text">Discord</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a href="https://twitter.com/8vGlobal" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/tw.png" class="im" />
        <span class="text">Twitter</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a
        href="https://www.reddit.com/user/8V_Global"
        target="_blank"
        class="it"
      >
        <img src="../../assets/img/aboutus-8v/contract/re.png" class="im" />
        <span class="text">Reddit</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
      <a href="https://t.me/global8v" target="_blank" class="it">
        <img src="../../assets/img/aboutus-8v/contract/tg.png" class="im" />
        <span class="text">Telegram</span>
        <i class="iconfont icongengduo-copy yellow"></i>
      </a>
    </div>
    <div class="s-o">
      <div class="split-bottom"></div>
    </div>
  </div>
</template>
<script>
import { translateTitle } from "@/assets/js/i18n";
import advantages from "@/assets/img/aboutus-8v/advantages.png";
import advantages1 from "@/assets/img/aboutus-8v/advantages1.png";
import advantages2 from "@/assets/img/aboutus-8v/advantages2.png";
import advantages3 from "@/assets/img/aboutus-8v/advantages3.png";
import advantages4 from "@/assets/img/aboutus-8v/advantages4.png";
import advantages5 from "@/assets/img/aboutus-8v/advantages5.png";
import advantages6 from "@/assets/img/aboutus-8v/advantages6.png";
import banner from "@/assets/img/aboutus-8v/banner.png";
import ben from "@/assets/img/aboutus-8v/ben.png";
import bottomLogo from "@/assets/img/aboutus-8v/bottom-logo.png";
// import bottom1 from "@/assets/img/aboutus-8v/bottom1.png";
// import bottom2 from "@/assets/img/aboutus-8v/bottom2.png";
// import bottom3 from "@/assets/img/aboutus-8v/bottom3.png";
// import bottom4 from "@/assets/img/aboutus-8v/bottom4.png";
import bottom1n from "@/assets/img/aboutus-8v/bottom1-n.png";
import bottom2n from "@/assets/img/aboutus-8v/bottom2-n.png";
import bottom3n from "@/assets/img/aboutus-8v/bottom3-n.png";
import customer from "@/assets/img/aboutus-8v/customer.png";
import logoSlogan from "@/assets/img/aboutus-8v/logo-slogan.png";
import nick from "@/assets/img/aboutus-8v/nick.png";
import roland from "@/assets/img/aboutus-8v/roland.png";
import userCentric from "@/assets/img/aboutus-8v/user-centric.png";
import vision from "@/assets/img/aboutus-8v/vision.png";
import { mapActions, mapGetters } from "vuex";

import { VUE_APP_ID, VUE_APP_APP } from "@/assets/js/stationSetting";
export default {
  components: {},
  data() {
    return {
      advantages1,
      advantages2,
      advantages3,
      advantages4,
      advantages5,
      advantages6,
      ben,
      nick,
      roland,
      // bottom1,
      // bottom2,
      // bottom3,
      // bottom4,
      bottom1n,
      bottom2n,
      bottom3n,
      isShowIntroduction: false,
      isShowSlogan: false,
      isShowCentric: false,
      isShowItem: 0,
      eco_active: 1,
    };
  },
  async created() {},
  computed: {
    ...mapGetters({
      language: "user/language",
    }),
  },
  methods: {
    translateTitle,
    doShowIntroduction() {
      this.isShowIntroduction = !this.isShowIntroduction;
    },
    doShowItem(num) {
      if (num === this.isShowItem) {
        this.isShowItem = 0;
      } else {
        this.isShowItem = num;
      }
    },
    doShowSlogan() {
      this.isShowSlogan = !this.isShowSlogan;
    },
    doShowCentric() {
      this.isShowCentric = !this.isShowCentric;
    },
    chooseEco(num) {
      this.eco_active = num;
    },
  },
};
</script>
<style lang="scss">
.aboutus-8v-page {
  .page-banner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-end;

    width: 100%;
    height: 927px;
    background: url("../../assets/img/aboutus-8v/banner.png") 0 0 no-repeat;
    background-size: 100% 100%;
    .bgvideo {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
    .logo-slogan {
      width: 100%;
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -75%);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .lg {
        width: auto;
        height: 140px;
      }
      .mt {
        text-align: center;
        margin-top: 20px;
        font-family: Georgia;
        font-size: 43px;
        letter-spacing: 1.13px;
        color: #f7b239;
      }
      .st {
        text-align: center;
        margin-top: 20px;
        font-size: 24px;
        font-weight: 600;
        letter-spacing: 2px;
        color: #fff;
      }
    }
    // .logo-slogan {
    //   width: 805px;
    //   height: 299px;
    //   background: url("../../assets/img/aboutus-8v/logo-slogan.png") 0 0
    //     no-repeat;
    //   background-size: 100% 100%;
    //   position: absolute;
    //   top: 50%;
    //   left: 50%;
    //   transform: translate(-50%, -50%);
    // }
    // .logo-slogan-en {
    //   width: 1487px;
    //   height: 312px;
    //   background: url("../../assets/img/aboutus-8v/logo-slogan-en.png") 0 0
    //     no-repeat;
    //   background-size: 100% 100%;
    //   position: absolute;
    //   top: 50%;
    //   left: 11.5%;
    //   transform: translate(0%, -50%);
    // }
    .rectangle {
      position: absolute;
      width: 100%;
      height: 192px;
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000);
      display: flex;
      justify-content: center;
      align-items: flex-end;
      .more-button {
        user-select: none;
        cursor: pointer;
        margin-bottom: 75px;
        width: 142px;
        height: 37px;
        padding: 0 20px 6px 23px;
        border-radius: 18.5px;
        border: solid 1px #f7b239;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: 500;
        color: #f7b239;
        .down {
          margin-left: 10px;
          margin-top: 5px;
        }
        .up {
          transform: rotate(180deg);
          margin-left: 10px;
          margin-top: 5px;
        }
      }
    }
  }
  .rectangle-content {
    position: relative;
    z-index: 10;
    width: 100%;
    padding-bottom: 30px;
    // height: 222px;
    background-color: #000;
    display: flex;
    justify-content: center;
    .introduction {
      font-family: PingFangTC;
      width: 76%;
      // height: 182px;
      margin-top: -20px;
      font-size: 22px;
      line-height: 2.14;
      letter-spacing: 2.16px;
      color: #a3a3a3;
      .site-name {
        color: #fff;
        margin-right: 10px;
      }
    }
  }
  .ecosystem {
    width: 100%;
    height: 1100px;
    background-color: #112132;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title-ecosystem {
      height: 56px;
      font-family: Graphik;
      font-size: 43px;
      font-weight: 600;
      color: #f7b239;
      margin-bottom: 65px;
    }
    .img-ecosystem {
      width: 1282.5px;
      height: 769.2px;
      position: relative;
      background: url("../../assets/img/aboutus-8v/ecosystem-bg.png") center
        no-repeat;
      background-size: 86% 86%;
      .text {
        display: block;
        width: 100px;
        margin-top: 115px;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 2px;
        color: #f7b239;
        margin-left: 32.5px;
      }
      .first {
        cursor: pointer;
        width: 165px;
        height: 165px;
        position: absolute;
        top: 0%;
        left: 25%;
        text-align: center;
        background: url("../../assets/img/aboutus-8v/crypto_dis.png") 0 0
          no-repeat;
        background-size: 100% 100%;
        &.active {
          background: url("../../assets/img/aboutus-8v/crypto_on.png") 0 0
            no-repeat;
          background-size: 100% 100%;
          .text {
            color: #fff;
          }
        }
      }
      .second {
        cursor: pointer;
        width: 165px;
        height: 165px;
        position: absolute;
        top: 0%;
        right: 25%;
        text-align: center;
        background: url("../../assets/img/aboutus-8v/Defi_dis.png") 0 0
          no-repeat;
        background-size: 100% 100%;
        &.active {
          background: url("../../assets/img/aboutus-8v/Defi_on.png") 0 0
            no-repeat;
          background-size: 100% 100%;
          .text {
            color: #fff;
          }
        }
      }
      .third {
        cursor: pointer;
        width: 165px;
        height: 165px;
        position: absolute;
        top: 37%;
        right: 0.8%;
        text-align: center;
        background: url("../../assets/img/aboutus-8v/adv_dis.png") 0 0 no-repeat;
        background-size: 100% 100%;
        &.active {
          background: url("../../assets/img/aboutus-8v/adv_on.png") 0 0
            no-repeat;
          background-size: 100% 100%;
          .text {
            color: #fff;
          }
        }
      }
      .fourth {
        cursor: pointer;
        width: 165px;
        height: 165px;
        position: absolute;
        bottom: -3%;
        right: 25%;
        text-align: center;
        background: url("../../assets/img/aboutus-8v/social_dis.png") 0 0
          no-repeat;
        background-size: 100% 100%;
        &.active {
          background: url("../../assets/img/aboutus-8v/social_on.png") 0 0
            no-repeat;
          background-size: 100% 100%;
          .text {
            color: #fff;
          }
        }
      }
      .fifth {
        cursor: pointer;
        width: 165px;
        height: 165px;
        position: absolute;
        bottom: -3%;
        left: 25%;
        text-align: center;
        background: url("../../assets/img/aboutus-8v/game_dis.png") 0 0
          no-repeat;
        background-size: 100% 100%;
        &.active {
          background: url("../../assets/img/aboutus-8v/game_on.png") 0 0
            no-repeat;
          background-size: 100% 100%;
          .text {
            color: #fff;
          }
        }
      }
      .sixth {
        cursor: pointer;
        width: 165px;
        height: 165px;
        position: absolute;
        top: 37%;
        left: 0.8%;
        text-align: center;
        background: url("../../assets/img/aboutus-8v/NFT_dis.png") 0 0 no-repeat;
        background-size: 100% 100%;
        &.active {
          background: url("../../assets/img/aboutus-8v/NFT_on.png") 0 0
            no-repeat;
          background-size: 100% 100%;
          .text {
            color: #fff;
          }
        }
      }
      .tc {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .t {
          display: inline-block;
          padding: 5px 30px;
          border-radius: 35px;
          color: #112132;
          background-color: #f7b239;
          font-size: 19px;
          font-weight: 500;
        }
        .c {
          margin-top: 60px;
          width: 270px;
          font-size: 17px;
          font-weight: 500;
          letter-spacing: 2.33px;
          text-align: center;
          color: #f7b239;
        }
      }
    }
  }
  .site-data {
    width: 100%;
    height: 262px;
    background-color: #000;
    padding: 0 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    .data-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .data {
          margin-bottom: 5px;
          font-size: 57px;
          font-weight: 600;
          color: #fff;
        }
        .title {
          font-size: 37px;
          font-weight: 600;
          color: #697786;
        }
      }
    }
  }
  .advantages {
    width: 100%;
    height: 1452px;
    background: #121e2c url("../../assets/img/aboutus-8v/advantages.png") 0 0
      no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title-cn-english {
      margin-top: 127px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 102px;
      .title-cn {
        font-size: 50px;
        font-weight: 600;
        color: #fff;
      }
      .title-english {
        font-size: 43px;
        font-weight: 500;
        color: #fff;
      }
    }
    .title-team-cn-english {
      margin-top: auto;
      margin-bottom: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title-cn {
        font-size: 50px;
        font-weight: 600;
        color: #fff;
      }
      .title-english {
        font-size: 43px;
        font-weight: 500;
        color: #fff;
      }
    }
    .advantages-items {
      width: 100%;
      padding: 0 15.6%;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .space {
        height: 100px;
        width: 150px;
      }
      .advantages-item-both {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .advantages-item-one {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .advantages-item-img {
            width: 102px;
            height: 102px;
            margin-bottom: 55px;
          }
          .advantages-item-p {
            height: 150px;
            font-size: 28px;
            font-weight: 500;
            color: #fff;
            text-align: center;
          }
        }
        .advantages-item-two {
          margin-top: 174px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .advantages-item-img {
            width: 102px;
            height: 102px;
            margin-bottom: 55px;
          }
          .advantages-item-p {
            font-size: 28px;
            font-weight: 500;
            color: #fff;
            text-align: center;
          }
        }
      }
    }
  }
  .team {
    width: 100%;
    height: 530px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: #121e2c;
    .space {
      height: 100px;
      width: 164px;
    }
    .team-item {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .item-image {
        width: 310px;
        height: 341px;
        border-radius: 10px;
        display: block;
      }
      .item-name {
        margin-top: 10px;
        font-size: 36px;
        font-weight: 500;
        color: #fff;
      }
      .item-work {
        font-size: 22px;
        font-weight: 500;
        color: #697786;
      }
      .cover {
        position: absolute;
        left: 0px;
        top: 0px;
        background: rgba(0, 0, 0, 0.8);
        width: 100%;
        height: 100%;
        z-index: 1;
        border-radius: 10px;
      }
    }
  }
  .name-introduction {
    width: 100%;
    height: 530px;
    background-color: #121e2c;
    padding: 0 14%;
    .name-work {
      width: 100%;
      font-size: 38px;
      font-weight: 600;
      color: #fff;
      display: flex;
      justify-content: space-between;
      .name {
      }
      .work {
      }
    }
    .work-content {
      margin-top: 48px;
      font-size: 24px;
      color: #a3a3a3;
    }
  }
  .vision {
    width: 100%;
    height: 749px;
    // background: url("../../assets/img/aboutus-8v/vision.png") 0 0 no-repeat;
    // background-size: 100% 100%;
    background: url("../../assets/img/aboutus-8v/vision.png") center center
      no-repeat;
    background-size: cover;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .vision-content {
      margin-right: 14%;
      width: 45%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      .title-small {
        font-size: 36px;
        font-weight: 600;
        color: #fff;
      }
      .title-big {
        font-size: 46px;
        font-weight: 600;
        color: #f7b239;
      }
      .slogan-one {
        margin-top: 40px;
        font-size: 20px;
        font-weight: 600;
        color: #a3a3a3;
      }
      .slogan-two {
        margin-top: 37px;
        font-size: 20px;
        font-weight: 600;
        color: #a3a3a3;
      }
      .slogan-three {
        font-size: 20px;
        font-weight: 600;
        color: #a3a3a3;
      }
      .more-button {
        margin-top: 63px;
        user-select: none;
        cursor: pointer;
        width: 142px;
        height: 37px;
        padding: 0 20px 6px 23px;
        border-radius: 18.5px;
        border: solid 1px #f7b239;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: 500;
        color: #f7b239;
        .down {
          margin-left: 10px;
          margin-top: 5px;
        }
        .up {
          transform: rotate(180deg);
          margin-left: 10px;
          margin-top: 5px;
        }
      }
    }
  }

  .centric {
    width: 100%;
    height: 738px;
    background: #121e2c url("../../assets/img/aboutus-8v/user-centric.png")
      center center no-repeat;
    // background-size: 100% 100%;
    background-size: cover;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .centric-content {
      margin-left: 11%;
      width: 45%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      .title-small {
        font-size: 36px;
        font-weight: 600;
        color: #fff;
      }
      .title-big {
        font-size: 46px;
        font-weight: 600;
        color: #f7b239;
      }
      .slogan-one {
        margin-top: 40px;
        font-size: 20px;
        font-weight: 600;
        color: #a3a3a3;
      }
      .slogan-two {
        margin-top: 37px;
        font-size: 20px;
        font-weight: 600;
        color: #a3a3a3;
      }
      .slogan-three {
        font-size: 20px;
        font-weight: 600;
        color: #a3a3a3;
      }
      .more-button {
        margin-top: 63px;
        user-select: none;
        cursor: pointer;
        width: 142px;
        height: 37px;
        padding: 0 20px 6px 23px;
        border-radius: 18.5px;
        border: solid 1px #f7b239;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: 500;
        color: #f7b239;
        .down {
          margin-left: 10px;
          margin-top: 5px;
        }
        .up {
          transform: rotate(180deg);
          margin-left: 10px;
          margin-top: 5px;
        }
      }
    }
  }

  .customer {
    width: 100%;
    height: 370px;
    background-color: #121e2c;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding: 106px 0 67px;
    .customer-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .item-image {
        width: 150px;
        height: 150px;
      }
      .work-title {
        margin-top: 24px;
        font-size: 30px;
        font-weight: 600;
        color: #f7b239;
      }
      .work-subTitle {
        margin-top: 2px;
        font-size: 17px;
        font-weight: 600;
        color: #fff;
      }
    }
    .space {
      width: 180px;
      height: 100px;
    }
  }
  .contract {
    width: 100%;
    padding: 0 300px 20px;
    background-color: #121e2c;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .it {
      margin-left: 30px;
      margin-bottom: 30px;
      padding: 8px;
      border-radius: 42.5px;
      border: solid 1.3px #fdb23c;
      background-color: #182c3c;
      display: flex;
      align-items: center;
      .im {
        width: 40px;
        height: 40px;
      }
      .text {
        margin-left: 15px;
        font-size: 15px;
        letter-spacing: 1px;
        color: #fff;
      }
      .yellow {
        margin-left: 70px;
        margin-right: 5px;
        font-size: 25px;
        font-weight: 600;
        color: #fdb23c;
      }
    }
  }
  .s-o {
    width: 100%;
    background-color: #121e2c;

    .split-bottom {
      width: 70%;
      height: 1px;
      background-color: #979797;
      margin: 0 auto;
    }
  }
}
// .ar {
//   .home-page .el-table tbody .cell .coin-content {
//     float: right;
//     margin-right: 80px;
//     .coin-img {
//       margin-left: 10px;
//     }
//   }

//   .home-page .home-content-four .left-content .tips-details li i {
//     margin-left: 6px;
//     margin-right: 0;
//   }
//   .home-page .home-content-four .left-content .download-content {
//     direction: ltr;
//   }
//   .home-page .home-content-four .left-content .download-code {
//     height: 160px;
//     .qr_code_canvas {
//       margin-right: 0;
//     }
//   }
// }
// .home-page {
//   margin-top: -2px;
//   // height: 2977px;
//   display: block;
//   [v-cloak] {
//     display: none;
//   }
//   .fiv-svg {
//     position: relative;
//     i {
//       z-index: 900;
//       position: absolute;
//       font-size: 60px;
//       top: -2px;
//       left: 110px;
//     }
//   }

//   // font-family: PingFangSC, BinancePlex, Arial, sans-serif !important;
//   .is-resiger {
//     height: 340px;
//   }
//   .no-resiger {
//     height: 340px;
//   }
//   user-select: none;
//   padding: 0;
//   // min-height: 2000px;
//   flex: 1;
//   .swiper-img {
//     width: 100%;
//     height: 144px;
//     border-radius: 6px;
//   }

//   .home-content-one {
//     // background: url("../../assets/img/home/home-bg.png") 0 0 repeat;
//     background: url("../../assets/svg/bg.svg") 0 0 repeat;
//     padding-bottom: 30px;
//     min-height: 340px;

//     .first-lable {
//       color: white;
//       font-size: 38px;
//       font-weight: bolder;
//       text-align: center;
//       padding-top: 80px;
//     }
//     .second-lable {
//       color: #d9dad8;
//       font-size: 14px;
//       text-align: center;
//       padding-top: 15px;
//     }
//   }
//   .home-content-two {
//     min-height: 788px;
//     background: #f8f9fd;
//     padding-bottom: 30px;
//     &.V2 {
//       min-height: 588px;
//     }
//     .swiper-sider-content {
//       display: flex;
//       justify-content: center;
//       padding-top: 30px;
//       position: static;
//       .swiper-next {
//         cursor: pointer;
//         display: flex !important;
//         justify-content: center !important;
//         align-items: center !important;
//         z-index: 99;
//         width: 30px;
//         height: 144px;
//         top: 0px;
//         outline: none;
//         position: absolute;
//         background-color: rgb(0, 0, 0, 0.4);
//         right: 0px;
//         border-top-right-radius: 6px;
//         border-bottom-right-radius: 6px;
//         img {
//           height: 17px;
//           width: 10px;
//         }
//       }
//       .swiper-prev {
//         cursor: pointer;
//         display: flex !important;
//         justify-content: center !important;
//         align-items: center !important;
//         z-index: 99;
//         width: 30px;
//         height: 144px;
//         top: 0px;
//         outline: none;
//         position: absolute;
//         background-color: rgb(0, 0, 0, 0.4);
//         left: 0px;
//         border-top-left-radius: 6px;
//         border-bottom-left-radius: 6px;
//         img {
//           height: 17px;
//           width: 10px;
//         }
//       }
//       .swiper-content {
//         display: flex;
//         position: relative;
//         align-items: center;
//         width: 1200px;
//         .button-prev {
//           margin-right: 13px;
//         }
//         i {
//           &:focus {
//             border: 0px;
//             outline: 0px;
//           }
//         }
//         .iconfont {
//           font-size: 28px;
//           color: #747a7e;
//           outline: none;
//           cursor: pointer;
//           border: 0px;
//         }
//         .swiper-container {
//           width: 1200px;
//           height: 144px;
//           position: relative;
//           border-radius: 6px;
//           .swiper-wrapper {
//             text-align: center !important;
//           }

//           img {
//             // width: 282px;
//             height: 144px;
//             // opacity: 0.7;
//             box-sizing: border-box;
//             opacity: 1;
//             &:hover {
//               opacity: 1;
//             }
//           }
//           .swiper-slide {
//             margin-left: 0px !important;
//           }
//         }
//       }
//       .old-img {
//         display: flex;
//         width: 1200px;
//         ul {
//           // width: 1110px;
//           &:last-child {
//             li img {
//               margin-right: 0;
//             }
//           }
//           li {
//             cursor: pointer;
//             // width: 282px;
//             // padding-right: 20px;
//           }
//         }

//         img {
//           width: 282px;
//           height: 144px;
//           margin-right: 24px;
//           border-radius: 5px;
//         }
//       }
//     }
//     .swiper-pagination {
//       position: relative !important;
//       margin-top: 15px;
//       span {
//         margin: 0px 10px;
//         // color: #9aa1b1;
//       }
//     }

//     .tips-massage-content {
//       padding: 20px 0px;
//       font-size: 14px;
//       color: #080c34;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       .left {
//         // min-width: 265px;
//         // width: auto;
//         i {
//           font-size: 16px;
//           color: #080c34;
//         }
//       }
//       .left-driver {
//         width: 1px;
//         height: 18px;
//         margin: 2px 15px 0;
//         background-color: #c2c7d0;
//       }

//       .bottom {
//         // min-width: 200px;
//         // margin-left: 15px;
//         text-align: left;
//       }
//       .article-title {
//         color: #080c34 !important;
//         min-width: 250px;
//       }
//       .right-driver {
//         width: 1px;
//         height: 18px;
//         margin: 2px 20px 0 15px;
//         background-color: #c2c7d0;
//       }
//       .right {
//         cursor: pointer;
//         i {
//           font-size: 14px;
//           color: #9aa1b1;
//           margin-top: 2px;
//           &:hover {
//             color: #3a7dff;
//           }
//         }
//         &:hover {
//           color: #3a7dff;
//           i {
//             color: #3a7dff;
//           }
//         }
//       }
//     }
//     .quotes-content {
//       width: 1200px;
//       // height: 572px;
//       margin: 0 auto;
//       padding: 20px 20px 0px;
//       border-radius: 6px;
//       box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.04);
//       background-color: #ffffff;
//       .left-symbol {
//         color: #354052;
//         font-size: 14px;
//         font-weight: 500;
//       }
//       .left-row {
//         color: #354052;
//         font-size: 14px;
//         font-weight: 600;
//       }

//       .el-table {
//         min-height: 430px !important;
//         tr {
//           cursor: pointer;
//         }
//       }
//       .el-tabs__nav-wrap::after {
//         height: 1px;
//         background-color: #f1f5f6;
//       }
//       .more-info {
//         display: flex;
//         align-items: center;
//         height: 72px;
//         justify-content: center;

//         text-align: center;
//         font-size: 16px;
//         color: #7f8490;
//         .more-title {
//           width: 102px;
//         }
//         .more {
//           cursor: pointer;
//           &:hover {
//             color: #3a7dff;
//             span {
//               color: #3a7dff;
//             }
//           }
//         }

//         span {
//           color: #9aa1b1;
//         }
//         .icongengduo {
//           font-size: 14px;
//           // margin-top: 4px;
//         }
//       }

//       .el-table {
//         min-height: 350px;
//         .el-icon-star-off {
//           cursor: pointer;
//         }
//       }
//       .el-table::before {
//         height: 0;
//       }
//     }
//   }
//   .home-content-three {
//     // background-color: #17232c;
//     background: url("../../assets/svg/bg.svg") 0 0 repeat;
//     text-align: center;
//     // overflow: hidden;
//     height: 350px;
//     .volume-title {
//       font-size: 32px;
//       font-weight: 600;
//       color: #fff;
//       line-height: 45px;
//       padding: 75px 0 12px;
//       .theme-red {
//         color: #c61b3d;
//       }
//     }

//     .volume-sub-title {
//       font-size: 14px;
//       font-weight: 400;
//       color: #fff;

//       line-height: 30px;
//     }

//     .point {
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       margin: 45px auto 80px;

//       &-item {
//         display: flex;
//         flex-direction: column;
//         margin-right: 175px;
//         p {
//           color: #ffffff;
//           font-size: 36px;
//           font-weight: 600;
//           height: 50px;
//         }

//         span {
//           font-size: 14px;
//           font-weight: 400;
//           color: #ffffff;
//           opacity: 0.5;
//           line-height: 25px;
//           // margin-top: 15px;
//         }
//       }

//       &-item:last-child {
//         margin-right: 0;
//       }
//     }
//   }
//   .home-content-four {
//     height: 600px;
//     text-align: center;
//     padding-bottom: 50px;

//     .content-title {
//       font-size: 36px;
//       font-weight: 600;
//       text-align: center;
//       margin: 60px 0 62px;
//       color: #354052;
//     }
//     .left-content {
//       display: inline-block;
//       text-align: left;
//       vertical-align: middle;
//       position: relative;
//       width: 400px;
//       // min-width: 420px;
//       // max-width: 500px;
//       margin-right: 80px;
//       .tips-details {
//         li {
//           display: flex;
//           i {
//             margin-top: 3px;
//             margin-right: 6px;
//             color: #c61b3d;
//           }
//         }
//       }

//       .left-content-title {
//         font-size: 18px;
//         font-weight: 600;
//         // width: 20px;
//         color: #1f2533;
//         margin-bottom: 25px;
//       }
//       li {
//         margin-bottom: 14px;
//         color: #354052;
//       }
//       img {
//         vertical-align: middle;
//         width: 16px;
//         height: 16px;
//         margin-right: 12px;
//       }
//       .download-content {
//         margin-top: 40px;
//         display: flex;
//         position: relative;
//         .download-item {
//           img {
//             width: 150px;
//             height: 50px;
//           }
//         }
//         .qr-code {
//           width: 55px;
//           height: 50px;
//           background-color: #1e2434;
//           padding: 13px 15px 12px;
//           border-radius: 3px;

//           img {
//             cursor: pointer;
//             text-align: center;
//             width: 25px;
//             height: 25px;
//             color: #ffffff;
//           }
//         }
//       }
//       .download-code {
//         // float: right;
//         // margin-right: 60px;
//         position: absolute;
//         right: 0px;
//         box-sizing: border-box;
//         width: 120px;
//         height: 145px;
//         border-color: #eaecef;
//         margin-top: 10px;
//         background: #ffffff;
//         padding: 10px;
//         border-radius: 4px;
//         z-index: 900;

//         img {
//           width: 100px;
//           height: 100px;
//         }
//         .scren-code {
//           width: 100%;
//           margin-top: 5px;
//           text-align: center;
//           box-sizing: border-box;
//           color: #1e2329;
//           font-size: 14px;
//         }
//       }
//     }
//     .right-content {
//       position: relative;
//       display: inline-block;
//       vertical-align: middle;
//       width: 718px;
//       height: 420px;
//       .home-bg-logo {
//         position: absolute;
//         top: 21px;
//         left: 6px;
//         img {
//           height: 16px;
//         }
//       }
//     }
//   }
//   .home-content-five {
//     height: 370px;

//     .content-title {
//       font-size: 36px;
//       font-weight: 600;
//       text-align: center;
//       margin: 60px 0 62px;
//       color: #1f2533;
//     }
//     .five-content {
//       display: flex;
//       justify-content: center;
//       .details {
//         display: flex;
//         width: 1120px;
//         justify-content: space-between;
//       }
//       .five-item {
//         text-align: center;
//         // width: 417px;

//         img {
//           width: 70px;
//           height: 70px;
//         }
//         .p-content {
//           font-size: 22px;
//           font-weight: 600;
//           text-align: center;
//           color: #1f2533;
//           margin-top: 15px;
//           margin-bottom: 25px;
//         }
//         .s-content {
//           margin-bottom: 77px;
//           width: 285px;
//           text-align: center;
//           color: #354052;
//           font-size: 14px;
//         }
//       }
//     }
//   }
//   .home-content-six {
//     height: 240px;
//     text-align: center;
//     background-color: #17232c;
//     .six-content {
//       height: 240px;
//       width: 100%;
//       padding: 64px 0 87px;
//     }
//     //  background: url("../../assets/svg/bg.svg") 0 0 repeat;
//     .six-content-title {
//       text-align: center;
//       color: #ffffff;
//       font-size: 22px;
//       font-weight: 600;
//     }
//   }
//   .regsiter-content {
//     margin: 42px 0px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     input {
//       display: inline-block;
//       width: 370px;
//       height: 46px;
//       margin: 0 10px 0 0;
//       font-size: 16px;
//       line-height: 46px;
//       font-weight: 500;
//       padding: 12px 0px 12px 17px;
//       border-radius: 2px;
//       background-color: #ffffff;
//       &::placeholder {
//         color: #dddee1;
//       }
//     }
//     .goRegsiter {
//       border-radius: 2px;
//       cursor: pointer;
//       vertical-align: middle;
//       background: #c61b3d;
//       text-align: center;
//       font-size: 16px;
//       display: inline-block;
//       width: 130px;
//       line-height: 46px;
//       height: 46px;
//       color: white;
//       box-sizing: border-box;
//     }
//     .trade-btn {
//       border-radius: 2px;
//       cursor: pointer;
//       vertical-align: middle;
//       background: #c61b3d;
//       text-align: center;
//       font-size: 16px;
//       display: inline-block;
//       width: 130px;
//       line-height: 46px;
//       height: 46px;
//       color: white;
//       box-sizing: border-box;
//     }
//   }

//   .el-table {
//     padding: 0px 0px 0 10px;
//     .el-table__header {
//       thead {
//         .cell {
//           font-size: 14px;
//           color: #7f8490;
//         }
//       }
//     }
//     tbody {
//       .operate {
//         width: 70px;
//         height: 28px;
//         padding: 4px 0px;
//         text-align: center;
//         border-radius: 2px !important;
//         background-color: #3a7dff;
//         border: 1px solid #3a7dff;
//         font-weight: 400 !important;
//         font-size: 14px;
//         box-sizing: border-box;
//         span {
//           font-weight: 400 !important;
//           color: #ffffff !important;
//         }
//       }
//       .mrket-img {
//         height: 30px;
//       }

//       .cell {
//         .coin-content {
//           display: inline-block;
//           .coin-img {
//             width: 30px;
//             height: 30px;
//             vertical-align: middle;
//           }
//         }
//         .red {
//           color: #c61b3d;
//         }
//         .green {
//           color: #03ad79;
//         }
//         .active {
//           color: #c61b3d;
//           font-size: 18px;
//           margin-top: 4px;
//           margin-left: -3px;
//         }
//         .el-icon-star-on,
//         .el-icon-star-off {
//           text-align: left;
//           cursor: pointer;
//           margin-right: 10px;
//         }
//         p,
//         span,
//         code {
//           color: #1f2533;
//           // font-weight: 600;
//         }
//         .el-table__expand-icon {
//           display: none;
//         }
//         .dark-color {
//           color: #9aa1b1;
//           font-size: 12px;
//         }
//       }
//     }

//     .table-expand {
//       min-height: 228px;
//       padding: 10px;
//       display: flex;
//       cursor: auto;
//       .expand-detail {
//         flex: 1;
//         display: inline-block;
//         margin-right: 32px;
//       }
//       .el-form {
//         display: inline-block;
//         width: 300px;
//         .el-form-item {
//           margin-bottom: 0px;
//           padding: 0 20px;
//           .el-form-item__label {
//             padding: 0;
//           }
//           &:nth-child(2n + 1) {
//             background-color: #f5f5f7;
//           }
//         }
//         .el-form-item__content {
//           display: inline-block;
//           float: right;
//         }
//       }
//     }
//   }
//   .el-tabs__item {
//     font-size: 16px;
//     margin-bottom: 10px;
//   }
//   input::-moz-placeholder {
//     /* Firefox 19+ */
//     color: #bec1c8 !important;
//     font-weight: 500;
//   }
//   input::-webkit-input-placeholder {
//     /* Chrome/Opera/Safari */
//     color: #bec1c8 !important;
//     font-weight: 500;
//   }

//   input:-ms-input-placeholder {
//     /* IE 10+ */
//     color: #bec1c8 !important;
//     font-weight: 500;
//   }

//   input:-moz-placeholder {
//     /* Firefox 18- */
//     color: #bec1c8 !important;
//     font-weight: 500;
//   }
// }
</style>
